export default {
  Form_Tips_Common: {
    enter_clinc_name: 'Please enter the clinic name',
    enter_clinc_code: 'Please enter the clinic code',
    enter_details_address: 'Please enter the details address',
    enter_phone: 'Please enter the phone number',
    select_administrator: 'Please select the administrator',
    letter_letters_numbers: 'Start letter, letters, numbers and hyphens only',
    QingShuRu_JingZhong: 'Please enter the Weight',
  },
}
